module.exports = __webpack_public_path__ + "f22c1023d584d43450e995b40edc21ca.png";